<template>
  <div>
    <h4 class="font-weight-bold pa-3 mb-0">
      Payslip
    </h4>
    
    <v-row class="mx-0">
      <v-col class="py-0">
        <v-menu
          v-model="payrollMonthMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
          max-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="payrollMonthDisplay"
              v-validate="'required'"
              :error-messages="errors.collect('payrollMonthDisplay')"            
              :disabled="!companyEmployee"
              data-vv-name="payrollMonthDisplay"
              data-vv-as="payroll month"
              label="Payroll Month"
              readonly
              class="label-position"
              v-on="on"
            >
              <template v-slot:prepend-inner>
                <v-icon>
                  mdi-calendar
                </v-icon>
              </template>
            </v-text-field>
          </template>

          <v-date-picker
            v-model="payrollMonth"
            type="month"
            :allowed-dates="allowedMonths"
            scrollable
            @input="payrollMonthMenu = false"
            @change="loadPayrollCycle"
          />
        </v-menu>
      </v-col>

      <v-col class="py-0">
        <v-autocomplete
          v-model="payrollCycle"
          v-validate="'required'"
          :items="payrollCycles"
          :disabled="!payrollMonth"
          item-text="name"
          item-value="id"
          label="Payroll Cycle"
          data-vv-as="payroll cycle"
          data-vv-name="payrollCycle"
          :error-messages="errors.collect('payrollCycle')"
          return-object
        />
      </v-col>

      <v-col class="ma-auto">
        <v-btn
          color="primary"
          :loading="progressing"
          @click="submitForm"
        >
          <v-icon class="mr-3">
            mdi-download
          </v-icon>
          Download
        </v-btn>
      </v-col>
      <v-col 
        v-if="payrollMonth && payrollCycle"
        cols="12"
        class="px-6 pb-2 mt-n3"
      >
        <v-icon
          class="pr-1"
          color="red"
        >
          mdi-information-outline
        </v-icon>
        
        <span
          v-if="companyEmployee.employee.person.lookup_citizenship && companyEmployee.employee.person.lookup_citizenship.value != 'MY'"
          class="dialog red--text"
        >
          Kindly note that this payslip is safeguarded with a password. Kindly input the last six characters of the employee's passport number for access.
        </span>
        <span
          v-else
          class="dialog red--text"
        >
          Kindly note that this payslip is safeguarded with a password. Kindly input the last six digits of the employee's IC number for access.
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      companyEmployee: {
        type: Object,
        default: null,
      },
    },
    data () {
      return {
        progressing: false,
        dates: [],
        payrollCycleEmployees: [],
        payrollCycles: [],
        payrollCycle: null,
        payrollMonth: null,
        payrollMonthMenu: false,
      }
    },
    computed: {
      payrollMonthDisplay () {
        return this.payrollMonth ? this.$moment(this.payrollMonth + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    watch: {
      companyEmployee: function (value) {
        if (value) { this.loadData() }
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true
            let payrollPeriod = this.dates.find(payrollDate => payrollDate.date === this.payrollMonth + '-01')

            this.$api.payslips().download(this.companyEmployee.company_employee_uid, this.payrollCycle.payroll_cycle_transaction_id, 'download')
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/pdf' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', this.$moment(payrollPeriod.date).format('MMM YYYY') + ' - ' + this.payrollCycle.name + ' payslip.pdf') 
                link.click()
                
                this.progressing = false
                this.$validator.reset()
                this.payrollMonth = null
                this.payrollCycle = null
                this.$snack({ message: 'Payslip downloaded successfully.' })
              })
          })
      },
      loadData () {
        this.dates = []
        this.$api.payslips().list(this.companyEmployee.company_employee_uid)
          .then(res => {
            this.payrollCycleEmployees = res.data

            this.payrollCycleEmployees.forEach(item => {
              this.dates.push({ id: item.payroll_cycle_transaction.payroll_period_id, date: item.payroll_cycle_transaction.payroll_period.payroll_date })
            })
            
            this.dates.sort((a, b) => {
              return a.date > b.date ? -1 : 1
            })
          })
      },
      loadPayrollCycle () {
        this.payrollCycles = []
        this.payrollCycle = null

        this.payrollCycleEmployees.filter(payrollCycleEmployee => {
          if (payrollCycleEmployee.payroll_cycle_transaction.payroll_period.payroll_date === this.payrollMonth + '-01') {
            this.payrollCycles.push({ 
              id: payrollCycleEmployee.payroll_cycle_transaction.payroll_cycle_id, 
              name: payrollCycleEmployee.payroll_cycle_transaction.payroll_cycle.name, 
              payroll_cycle_transaction_id: payrollCycleEmployee.payroll_cycle_transaction_id,
            })
          }
        })
        
        if (this.payrollCycles.length === 1) {
          this.payrollCycle = this.payrollCycles[0]
        }
      },
      allowedMonths (val) {
        let tempMonths = []
        this.dates.forEach(payrollMonth => {
          tempMonths.push(payrollMonth.date.slice(0, -3))
        })

        if (tempMonths.indexOf(val) !== -1) {
          return true
        } else {
          return false
        }
      },
    },
  }
</script>
